/** Module-level state for the single Ketcher panel (spec §8.9). */
import { useSyncExternalStore } from "react";
import type { LoroMap, TreeID } from "loro-crdt";
import type { DocHandle } from "../sync/docManager";

export interface ChemTarget {
  handle: DocHandle;
  treeId: TreeID;
  body: LoroMap;
  /** which save path applies (spec §8.9.1 point 3 vs §8.9.2); defaults to chemistry */
  blockType?: "chemistry" | "reaction";
}

let target: ChemTarget | null = null;
const listeners = new Set<() => void>();

export function openChemPanel(t: ChemTarget): void {
  target = t;
  listeners.forEach((l) => l());
}
export function closeChemPanel(): void {
  target = null;
  listeners.forEach((l) => l());
}
export function useChemTarget(): ChemTarget | null {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => target,
    () => target,
  );
}
